"use client";

import React, { useState } from "react";
import { Link } from "@/components/common/Link";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle, CardDescription, CardFooter } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ArrowRight, Sofa, Armchair } from "lucide-react";
export default function AbileneLivingOptions() {
  const [listingType, setListingType] = useState<"furnished" | "unfurnished">("furnished");
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="abilene-living-options" className="relative min-h-[85vh] flex items-center justify-center overflow-hidden py-24">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-black/50 z-10" />
        <div className="h-full w-full bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1553193/img/abilene_residential_neighborhood.png)]" />
      </div>

      {}
      <div ref={ref} className={`relative z-20 w-full max-w-3xl px-4 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <Card className="border-none shadow-2xl bg-card/95 backdrop-blur-md overflow-hidden rounded-none">
          <CardHeader className="text-center pb-4 pt-10 px-6 md:px-12">
            <CardTitle className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-foreground mb-6 tracking-tight">
              Choices for Every Stage
            </CardTitle>
            <CardDescription className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto leading-relaxed">
              Whether you need a move-in ready space or a blank canvas for your own style,
              we have the perfect home for you in Abilene.
            </CardDescription>
          </CardHeader>

          <CardContent className="flex flex-col items-center gap-8 px-6 md:px-12 pb-8">
            {}
            <div className="w-full flex justify-center">
              <div className="bg-muted p-1.5 rounded-none inline-flex border border-border/50">
                <ToggleGroup type="single" value={listingType} onValueChange={value => {
                if (value) setListingType(value as "furnished" | "unfurnished");
              }} className="gap-1">
                  <ToggleGroupItem value="furnished" className="px-6 py-3 h-auto rounded-none data-[state=on]:bg-background data-[state=on]:text-foreground data-[state=on]:shadow-sm data-[state=on]:ring-1 data-[state=on]:ring-black/5 transition-all duration-300 flex gap-2.5 items-center text-base" aria-label="Show furnished properties">
                    <Sofa className="w-5 h-5" />
                    <span className="font-medium">Furnished</span>
                  </ToggleGroupItem>
                  <ToggleGroupItem value="unfurnished" className="px-6 py-3 h-auto rounded-none data-[state=on]:bg-background data-[state=on]:text-foreground data-[state=on]:shadow-sm data-[state=on]:ring-1 data-[state=on]:ring-black/5 transition-all duration-300 flex gap-2.5 items-center text-base" aria-label="Show unfurnished properties">
                    <Armchair className="w-5 h-5" />
                    <span className="font-medium">Unfurnished</span>
                  </ToggleGroupItem>
                </ToggleGroup>
              </div>
            </div>

            {}
            <div key={listingType} className="text-center space-y-4 animate-in fade-in slide-in-from-bottom-2 duration-500 fill-mode-both">
               {listingType === 'furnished' ? <div className="space-y-2 max-w-lg mx-auto">
                   <h3 className="text-xl font-semibold text-foreground">Move-In Ready Comfort</h3>
                   <p className="text-muted-foreground">
                     Perfect for short-term stays, corporate housing, or hassle-free relocation.
                     Enjoy fully equipped spaces designed for comfort from day one.
                   </p>
                 </div> : <div className="space-y-2 max-w-lg mx-auto">
                   <h3 className="text-xl font-semibold text-foreground">Your Personal Touch</h3>
                   <p className="text-muted-foreground">
                     Ideal for long-term residents looking to establish roots.
                     Bring your own furniture and make the space truly yours.
                   </p>
                 </div>}
            </div>
          </CardContent>

          
        </Card>
      </div>
    </section>;
}